/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Automatic_Save_Restore_Point_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to create a restore point. {message}" |
*
* @param {Automatic_Save_Restore_Point_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_restore_point_failed = /** @type {((inputs: Automatic_Save_Restore_Point_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Restore_Point_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la création d’un point de restauration. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Es konnte kein Wiederherstellungspunkt erstellt werden. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile creare un punto di ripristino. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось создать точку восстановления. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo crear un punto de restauración. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`创建还原点失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`復元ポイントの作成に失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पुनर्स्थापना बिंदु बनाने में विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao criar um ponto de restauração. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Failed to create a restore point. ${i?.message}`)
});